import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-2">
            <a href="/" className="inline-block text-xl font-heading font-semibold text-foreground-950 tracking-tight mb-3">
              CSSBuy<span className="text-primary-500">BR</span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4 max-w-xs">
              {t('hero.trust')}
            </p>
            <p className="text-xs text-foreground-500 italic">
              {t('finalCta.disclaimer')}
            </p>
          </div>

          {/* Spreadsheet */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">{t('footer.spreadsheet')}</h4>
            <ul className="space-y-2">
              <li><a href="/cssbuy-spreadsheet/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.spreadsheet')}</a></li>
              <li><a href="/cssbuy-review/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.review')}</a></li>
              <li><a href="/cssbuy-shipping-cost/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.shipping')}</a></li>
              <li><a href="/cssbuy-warehouse/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.warehouse')}</a></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">{t('footer.categories')}</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">{t('footer.guides')}</h4>
            <ul className="space-y-2">
              <li><a href="/cssbuy-coupon/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.coupon')}</a></li>
              <li><a href="/cssbuy-legit/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.legit')}</a></li>
              <li><a href="/safety/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.safety')}</a></li>
              <li><a href="/faq/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.faq')}</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">{t('footer.legal')}</h4>
            <ul className="space-y-2">
              <li><a href="/about/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.about')}</a></li>
              <li><a href="/contact/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.contact')}</a></li>
              <li><a href="/privacy-policy/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.privacy')}</a></li>
              <li><a href="/terms/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.terms')}</a></li>
              <li><a href="/disclaimer/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('footer.disclaimerLink')}</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 text-center md:text-left">
            {t('footer.disclaimer')}
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}